export default import.meta.ROLLDOWN_FILE_URL_SLECS9RVvDI9k1rbqqFKLQ